<h2 mat-dialog-title>
  <span class="title-text">Add Standard Vehicle</span>
  <button mat-icon-button mat-dialog-close aria-label="Close" class="close-button">
    <i class="material-icons">close</i>
  </button>
</h2>
<div mat-dialog-content class="dialog-content" [formGroup]="form">
  <div class="form-grid">
    <div class="field full">
      <div class="label">{{ data?.loadType === 'FCL' ? 'Select Container Type' : 'Select Vehicle Type' }}</div>
      <mat-form-field appearance="outline" class="hmt-form-field full-width">
        <mat-select formControlName="type" [placeholder]="data?.loadType === 'FCL' ? 'Container Type' : 'Vehicle Type'" (selectionChange)="onCategorySelected($event.value)">
          <mat-option *ngFor="let c of (standardVehicleCategories$ | async) || []" [value]="c.categoryName">
            {{ c.categoryName }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="quantity-field field">
      <div class="label">Quantity</div>
      <div class="quantity-selector">
        <button type="button" class="icon-btn" (click)="decrease()">
          <mat-icon>remove</mat-icon>
        </button>
        <input
          type="number"
          class="quantity-input"
          formControlName="quantity"
          min="1"
          step="1"
          (input)="onQuantityInput($any($event.target).value)">
        <button type="button" class="icon-btn" (click)="increase()">
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </div>

    <div class="field" *ngIf="data?.loadType != 'FCL'">
      <div class="label cost-label">Cost Per KM <span class="required-mark">*</span></div>
      <mat-form-field appearance="outline" class="hmt-form-field cost">
        <input matInput type="number" formControlName="costPerKm" step="0.001" min="0" (input)="limitDecimalPlaces($event, 'costPerKm', 2)" />
      </mat-form-field>
      <div class="error-hint" *ngIf="form.get('costPerKm')?.invalid && (form.get('costPerKm')?.touched || form.get('costPerKm')?.dirty)">
        Cost Per KM is required and must be greater than 0.
      </div>
    </div>
    <div class="field" *ngIf="data?.loadType == 'FCL'"> </div>
    <div class="field">
      <div class="label">Max Carrying Weight</div>
      <div class="input-with-unit">
        <div class="unit-display editable">
          <input 
            type="number" 
            class="value-input" 
            formControlName="maxCarryingWeight"
            step="0.001"
            min="0"
            (input)="limitDecimalPlaces($event, 'maxCarryingWeight', 3)">
          <span class="divider"></span>
          <span class="unit">KG</span>
        </div>
      </div>
    </div>

    <div class="field">
      <div class="label">Maximum Capacity</div>
      <div class="input-with-unit">
        <div class="unit-display editable">
          <input 
            type="number" 
            class="value-input" 
            formControlName="maxCapacity"
            step="0.001"
            min="0"
            (input)="limitDecimalPlaces($event, 'maxCapacity', 3)">
          <span class="divider"></span>
          <span class="unit">CBM</span>
        </div>
      </div>
    </div>
  </div>

  <div class="utilization" *ngIf="data?.loadType != 'FCL'">
    <div class="label">Vehicle Capacity Utilization</div>
    <div class="utilization-controls">
      <div class="slider-row">
        <div class="slider-and-marks-wrapper">
          <div class="slider-wrapper">
            <div class="bubble" [style.left.%]="(utilization$ | async) ?? 0">
              {{ ((utilization$ | async) ?? 100) }}%
            </div>
            <input 
              type="range"
              min="0"
              max="100"
              step="1"
              formControlName="utilization"
              class="utilization-slider html-range-slider"
              [style.background]="(sliderBg$ | async) || ''">
          </div>
          <div class="slider-marks">
        <div class="mark-item">
          <span class="tick long"></span>
          <span class="label">0</span>
        </div>
        <div class="mark-item">
          <span class="tick short"></span>
        </div>
        <div class="mark-item">
          <span class="tick long"></span>
          <span class="label">20</span>
        </div>
        <div class="mark-item">
          <span class="tick short"></span>
        </div>
        <div class="mark-item">
          <span class="tick long"></span>
          <span class="label">40</span>
        </div>
        <div class="mark-item">
          <span class="tick short"></span>
        </div>
        <div class="mark-item">
          <span class="tick long"></span>
          <span class="label">60</span>
        </div>
        <div class="mark-item">
          <span class="tick short"></span>
        </div>
        <div class="mark-item">
          <span class="tick long"></span>
          <span class="label">80</span>
        </div>
        <div class="mark-item">
          <span class="tick short"></span>
        </div>
        <div class="mark-item">
          <span class="tick long"></span>
          <span class="label">100</span>
        </div>
          </div>
        </div>
        <div class="utilization-input-box">
          <input 
            type="number" 
            class="number-input" 
            [value]="(utilization$ | async) ?? 100"
            (input)="onUtilizationInput($any($event.target).value)"
            min="0" 
            max="100">
        </div>
      </div>
    </div>
  </div>
</div>

<div mat-dialog-actions align="end" class="dialog-actions">
  <button mat-stroked-button color="primary" class="reset-btn" (click)="reset()">Reset</button>
  <button mat-flat-button color="primary" class="add-btn" [disabled]="!form.valid" (click)="save()">Add</button>
</div>
